/** Handling days at which an offer reads as long handling, unless the caller sets its own. */
const DEFAULT_LONG_HANDLING_DAYS = 6;

export default function getStockedMessage(
  vendorOption: VendorOptionState,
  longHandlingDays: number = DEFAULT_LONG_HANDLING_DAYS,
): StockedState {
  if (vendorOption?.isBackordered) {
    return StockedState.BACKORDERED;
  } else if (vendorOption?.shippingTime >= longHandlingDays) {
    return StockedState.LONG_HANDLING_TIME;
  } else if (vendorOption?.isFulfillmentPolicyStock === true && vendorOption?.shippingTime <= 3) {
    return StockedState.STOCKED;
  } else {
    return StockedState.UNKNOWN;
  }
}

export enum StockedState {
  LONG_HANDLING_TIME = "Long Handling Time",
  STOCKED = "Stocked",
  BACKORDERED = "Backordered",
  UNKNOWN = "null",
}
